export default "__VITE_ASSET__Blmw_qXS__"